module.exports = __webpack_public_path__ + "media/images/humidity-2c01b2da56286090c4eafc3608a1083b.png";